import type { FC } from "preact/compat";
import { Outlet } from "react-router-dom";
import { Meta } from "~/organisms";
import cn from "classnames";

const Public: FC = () => (
    <div
        className={cn(
            "w-screen h-screen max-w-screen max-h-screen overflow-hidden flex flex-col",
            "top-[calc(-1*var(--safe-top))] relative",
            "bg-gradient-to-br from-ocean to-sky-900 text-white",
        )}
    >
        <Meta />
        <Outlet />
    </div>
);

export default Public;
